var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-field',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('md-input',{attrs:{"type":"number","step":_vm.step,"min":_vm.min,"max":_vm.max,"value":_vm.value,"required":_vm.required,"disabled":_vm.disabled},on:{"input":_vm.updateValue,"keypress":_vm.validateInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }